
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/skiduthyrning",
      function () {
        return require("private-next-pages/[region]/[resort]/skiduthyrning.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/skiduthyrning"])
      });
    }
  